<template>
  <div class="header">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 title">
          <div v-scrollreveal class="sr_prevent_flickering">
            <h1>Intel Desk</h1>
            <h4>
              The InfoFi platform for crowdsourced investigations, where
              findings are ranked by impact and mindshare. Powered by $BMT.
            </h4>
          </div>
          <div>
            <Button
              raised
              v-scrollreveal="{ duration: 2000 }"
              class="header__button"
              link="https://intel.bubblemaps.io"
              target="_blank"
            >
              Start Now
            </Button>
            <Button
              outlined
              v-scrollreveal="{ duration: 2000 }"
              class="header__button"
              link="https://wiki.bubblemaps.io/intel-desk"
              target="_blank"
            >
              Wiki
            </Button>
          </div>
        </div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6">
          <wistia-player
            media-id="iinaoahj30"
            seo="false"
            class="video-player"
            aspect="1.7777777777777777"
          ></wistia-player>
        </div>
      </div>
    </div>
  </div>
  <div class="inteldesk-page">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <h2>Crowdsourced Intelligence.<br />For Everyone.</h2>
          <h4>
            Collective intelligence outperforms any individual. The Intel Desk
            <b
              >transforms the noise of a crypto investigation into a clear
              feed</b
            >, ranking key findings and showing how the story unfolded. <br />
            <br />
            Meet the <b>Mappers</b> – detectives on X who spend their time
            uncovering what really happened.
          </h4>
        </div>
      </div>
    </div>
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <!-- 1 -->
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-5-desktop offset-2-grid"
        >
          <h3>Start an Investigation</h3>
          <p>
            Suspect a hack? Spot unusual flows? Create a case and rally the
            community to dig deeper.
          </p>
          <div class="inteldesk__list-item">
            <SvgRightIcon />You need 100 BMT to submit a case
          </div>
          <div class="inteldesk__list-item">
            <SvgRightIcon />Submit a case first to earn a badge (and more!)
          </div>
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-5-desktop sr_prevent_flickering noselect"
          v-scrollreveal
        >
          <img
            src="@/assets/screenshots/inteldesk/open-case.png"
            class="inteldesk__screenshot"
            alt="Intel Desk screenshot"
          />
        </div>
        <!-- 2 -->
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-5-desktop inteldesk__odd--left"
        >
          <h3>Signal What Matters</h3>
          <p>Use your BMT to vote on the cases that deserve attention</p>
          <div class="inteldesk__list-item">
            <SvgRightIcon />
            The more votes, the higher the case multiplier – boosting the impact
            of each contribution.
          </div>
          <div class="inteldesk__list-item">
            <SvgRightIcon />
            Incentives are aligned – the community sets the focus, mappers get
            rewarded for adding value
          </div>
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-5-desktop sr_prevent_flickering noselect offset-2-grid"
          v-scrollreveal
        >
          <img
            src="@/assets/screenshots/inteldesk/case-page.png"
            class="inteldesk__screenshot"
            alt="Intel Desk screenshot"
          />
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-5-desktop inteldesk__odd--right"
        >
          <h3>Signal What Matters</h3>
          <p>Use your BMT to vote on the cases that deserve attention</p>
          <div class="inteldesk__list-item">
            <SvgRightIcon />
            The more votes, the higher the case multiplier – boosting the impact
            of each contribution.
          </div>
          <div class="inteldesk__list-item">
            <SvgRightIcon />
            Incentives are aligned – the community sets the focus, mappers get
            rewarded for adding value
          </div>
        </div>
        <!-- 3 -->
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-5-desktop offset-2-grid"
        >
          <h3>Follow the Investigation</h3>
          <p>
            Follow every step of the story – or contribute directly by tweeting.
          </p>
          <div class="inteldesk__list-item">
            <SvgRightIcon />Tweets are ranked by impact and added to the case
            feed
          </div>
          <div class="inteldesk__list-item">
            <SvgRightIcon />Mappers climb the leaderboard with each key insight
          </div>
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-5-desktop sr_prevent_flickering noselect"
          v-scrollreveal
        >
          <img
            src="@/assets/screenshots/inteldesk/leaderboard.png"
            class="inteldesk__screenshot"
            alt="Intel Desk screenshot"
          />
        </div>
        <!-- 4 -->
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-5-desktop inteldesk__odd--left"
        >
          <h3>Discover Top Mappers</h3>
          <p>Browse investigators profiles to track their work across cases</p>
          <div class="inteldesk__list-item">
            <SvgRightIcon />
            See every investigation a user contributed to
          </div>
          <div class="inteldesk__list-item">
            <SvgRightIcon />
            Connect your X account. Build your reputation and showcase your
            findings
          </div>
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-5-desktop sr_prevent_flickering noselect offset-2-grid"
          v-scrollreveal
        >
          <img
            src="@/assets/screenshots/inteldesk/mapper-page.png"
            class="inteldesk__screenshot"
            alt="Intel Desk screenshot"
          />
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-5-desktop inteldesk__odd--right"
        >
          <h3>Discover Top Mappers</h3>
          <p>Browse investigators profiles to track their work across cases</p>
          <div class="inteldesk__list-item">
            <SvgRightIcon />
            See every investigation a user contributed to
          </div>
          <div class="inteldesk__list-item">
            <SvgRightIcon />
            Connect your X account. Build your reputation and showcase your
            findings
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/atoms/material/Button.vue";

export default {
  name: "IntelDesk",
  components: {
    Button,
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/variables";

.header {
  @include theme-almost-black-gradient(45deg);
  margin-top: -56px;
  padding-top: 56px;

  .header__button {
    margin: 5px;
  }
}

@media (min-width: $mdc-tablet) {
  .header {
    margin-top: -64px;
    padding-top: 64px;
  }
}

.title {
  text-align: center;
  padding-top: 70px;
  padding-bottom: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    margin-top: 0;
    margin-bottom: 1rem;
    @include scaling-title(2.1rem, 540px, 400px);
  }

  h4 {
    margin-bottom: 30px;
    max-width: 580px;
  }
}

@media (max-width: $mdc-tablet) {
  .title {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}

wistia-player[media-id="iinaoahj30"]:not(:defined) {
  background: center / contain no-repeat
    url("https://fast.wistia.com/embed/medias/iinaoahj30/swatch");
  display: block;
  filter: blur(5px);
  padding-top: 56.25%;
}

.video-player {
  max-width: 800px;
  margin: auto;
  margin: 0 0 60px 0;
  aspect-ratio: 1.7777777777777777;
}

.inteldesk-page {
  background: url("../assets/backgrounds/blur.png") no-repeat center,
    url("../assets/backgrounds/blur-lqip.png") no-repeat center, #2727b7;
  background-size: cover;
  padding-top: 56px;
  padding-bottom: 60px;

  h4 {
    text-align: center;
    font-size: 1.4rem;
    margin-bottom: 80px;
    opacity: 1;
  }

  h2 {
    text-align: center;
  }
}

.inteldesk__list-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;

  svg {
    width: 30px;
    height: 30px;
    fill: $theme-pink;
    flex-shrink: 0;
  }
}

@media (min-width: $mdc-tablet) {
  .inteldesk-page {
    padding-top: 64px;
  }
}

@media (min-width: $mdc-grid-desktop) {
  .video-player {
    margin: 60px 0;
  }
}

@media (min-width: $mdc-grid-tablet) and (max-width: calc($mdc-grid-desktop - 1px)) {
  .header {
    .mdc-layout-grid__cell--span-6 {
      grid-column-start: 2;
    }
  }
}

.inteldesk__screenshot {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
  position: relative;
  transition: transform 200ms ease-in-out;
  object-fit: cover;
}

.inteldesk__odd--right {
  display: none;
}

@media (min-width: $mdc-grid-desktop) {
  .inteldesk__odd--left {
    display: none;
  }
  .inteldesk__odd--right {
    display: block;
  }
  .offset-2-grid {
    grid-column-start: 2;
  }
}
</style>
